export default __webpack_public_path__ + "42522d52c664f25850f3fe3e10137659.png";